import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    reload: { type: Boolean, default: true }
  }

  connect() {
    // Wait for Lucide icons to render, then init drag/drop
    setTimeout(() => this.initDragAndDrop(), 100)
  }

  initDragAndDrop() {
    const cards = this.element.querySelectorAll('[data-controller="card"]')

    cards.forEach(card => {
      // Make the whole card draggable, use pin as visual indicator
      card.setAttribute('draggable', 'true')
      card.classList.add('cursor-grab')

      card.addEventListener('dragstart', (e) => this.handleDragStart(e, card))
      card.addEventListener('dragover', (e) => this.handleDragOver(e, card))
      card.addEventListener('dragleave', (e) => this.handleDragLeave(e, card))
      card.addEventListener('drop', (e) => this.handleDrop(e, card))
      card.addEventListener('dragend', (e) => this.handleDragEnd(e))
    })
  }

  handleDragStart(e, card) {
    this.draggedCard = card
    card.classList.add('opacity-50', 'cursor-grabbing')
    card.classList.remove('cursor-grab')
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/plain', card.dataset.cardId)
  }

  handleDragOver(e, card) {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
    if (this.draggedCard && this.draggedCard !== card) {
      card.classList.add('ring-2', 'ring-cyan-400')
    }
  }

  handleDragLeave(e, card) {
    card.classList.remove('ring-2', 'ring-cyan-400')
  }

  handleDrop(e, targetCard) {
    e.preventDefault()
    targetCard.classList.remove('ring-2', 'ring-cyan-400')

    if (!this.draggedCard || this.draggedCard === targetCard) return

    const parent = targetCard.parentNode
    const allCards = Array.from(parent.children)
    const draggedIndex = allCards.indexOf(this.draggedCard)
    const targetIndex = allCards.indexOf(targetCard)

    if (draggedIndex < targetIndex) {
      parent.insertBefore(this.draggedCard, targetCard.nextSibling)
    } else {
      parent.insertBefore(this.draggedCard, targetCard)
    }

    this.saveOrder()
  }

  handleDragEnd(e) {
    if (this.draggedCard) {
      this.draggedCard.classList.remove('opacity-50', 'cursor-grabbing')
      this.draggedCard.classList.add('cursor-grab')
      this.draggedCard = null
    }
    // Remove any lingering highlights
    this.element.querySelectorAll('.ring-2').forEach(el => {
      el.classList.remove('ring-2', 'ring-cyan-400')
    })
  }

  saveOrder() {
    const allCards = this.element.querySelectorAll('[data-controller="card"]')
    const cardIds = Array.from(allCards).map(card => card.dataset.cardId)

    const sortUrl = this.element.dataset.boardSortUrl
    if (sortUrl) {
      fetch(sortUrl, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ card_ids: cardIds })
      }).then(response => {
        if (response.ok && this.reloadValue) {
          window.location.reload()
        }
      }).catch(err => {
        console.error('Failed to save card order:', err)
      })
    }
  }

  export() {
    const cards = this.element.querySelectorAll('[data-controller="card"]')
    const exportData = Array.from(cards).map(card => ({
      id: card.dataset.cardId,
      content: card.textContent.trim()
    }))

    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'board-export.json'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }
}
